import { cx } from '@libs/classnames';
import { ChessOpenIcon } from '@ui/icons/ChessOpenIcon';
import { FeatherIcon } from '@ui/icons/FeatherIcon';
import { PlayGradientIcon, PlayIcon } from '@ui/icons/PlayIcon';
import { TournamentsIcon } from '@ui/icons/TournamentsIcon';

import styles from './SiteLogo.module.css';

export type Props = {
  className?: string;
  variant: 'chessopen-tournaments' | 'chessopen-play' | 'chessopen-play-monochrome' | 'chessopen';
};
export function SiteLogo({ className, variant }: Props) {
  if (variant === 'chessopen-play' || variant === 'chessopen-play-monochrome') {
    return (
      <div className={cx(styles.siteLogo, styles[variant], className)}>
        <FeatherIcon className={styles.feather} />
        <ChessOpenIcon className={styles.chessOpen} />
        {variant === 'chessopen-play-monochrome' ? (
          <PlayIcon className={styles.play} />
        ) : (
          <PlayGradientIcon className={styles.play} />
        )}
      </div>
    );
  }

  if (variant === 'chessopen') {
    return (
      <div className={cx(styles.siteLogo, styles[variant], className)}>
        <FeatherIcon className={styles.feather} />
        <ChessOpenIcon className={styles.chessOpen} />
      </div>
    );
  }

  return (
    <div className={cx(styles.siteLogo, styles[variant], className)}>
      <FeatherIcon className={styles.feather} />
      <ChessOpenIcon className={styles.chessOpen} />
      <TournamentsIcon className={styles.tournaments} />
    </div>
  );
}
